import React, { useState } from 'react';
import AdminNavigation from './AdminNavigation';
import Input from '../common/Input';
import { useFormik } from 'formik';
import { reprintTokenList, reprintToken } from '../service/tokenService';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import DataTable from '../common/DataTable';
import { Link } from 'react-router-dom';

export default function TokenReprint() {
   const [items, setItems] = useState([]);
   const [token, setToken] = useState('');
   const formik = useFormik({
      initialValues: { meterNumber: '', tokens: 0 },
      validationSchema: validation,
      onSubmit: (values, setSubmitting) => {
         handleFindTokens(values);
         setSubmitting(false);
      },
   });
   const handleFindTokens = (values) => {
      const requestData = {
         meterNumber: values.meterNumber,
         tokens: parseInt(values.tokens),
      };
      reprintTokenList(requestData)
         .then((response) => {
            const foundTokens = response.data.data;
            if (foundTokens.length === 0) {
               toast.info('No tokens fo the given meter', { autoClose: 2000 });
            } else setItems(foundTokens);
         })
         .catch((error) => {
            toast.error('Could not tokens for this meter', { autoClose: 2000 });
         });
   };

   const handleReprintToken = (receiptNumber) => {
      const requestData = {
         receiptNumber: receiptNumber,
      };
      reprintToken(requestData)
         .then((response) => {
            const foundToken = response.data;
            if (foundToken.length === 0) {
               toast.info('No tokens fo the given meter', { autoClose: 2000 });
            } else setToken(foundToken);
         })
         .catch((error) => {
            toast.error('Could not tokens for this meter', { autoClose: 2000 });
         });
   };

   const columns = [
      {
         columnCaption: 'Receipt Number',
         columnKey: 'receiptNumber',
         content: (item) => <span onClick={() => handleReprintToken(item.receiptNumber)}>{item.receiptNumber}</span>,
      },
      {
         columnCaption: 'Amount',
         columnKey: 'amount',
      },
   ];

   return (
      <div className='container'>
         <div className='row'>
            <div className='col-md-3'>
               <AdminNavigation />
            </div>
            <div className='col-md-9'>
               <div className='row'>
                  <div className='col-md-12'>
                     <form className='form' onSubmit={formik.handleSubmit}>
                        <div className='form-row'>
                           <div className='form-group col-md-4'>
                              <label>Meter Number</label>
                              <Input
                                 type='text'
                                 className='form-control form-control-sm custom-input'
                                 name='meterNumber'
                                 id='meterNumber'
                                 value={formik.values.meterNumber}
                                 onChange={formik.handleChange}
                              />
                              {formik.errors.meterNumber && formik.touched.meterNumber && (
                                 <div className='invalid-feedback'>{formik.errors.meterNumber}</div>
                              )}
                           </div>
                           <div className='form-group col-md-4'>
                              <label>Number of Tokens</label>
                              <Input
                                 type='text'
                                 className='form-control form-control-sm custom-input'
                                 name='tokens'
                                 id='tokens'
                                 value={formik.values.tokens}
                                 onChange={formik.handleChange}
                              />
                              {formik.errors.tokens && formik.touched.tokens && <div className='invalid-feedback'>{formik.errors.tokens}</div>}
                           </div>
                        </div>

                        <button type='submit' className='btn btn-primary btn-sm btn-custom-blue mr-2'>
                           Search
                        </button>
                        <button type='button' className='btn btn-outline-secondary btn-sm search-button' onClick={formik.handleReset}>
                           Cancel
                        </button>
                     </form>
                  </div>
               </div>
               <div className='row'>
                  <div className='col-md-6'>
                     <div className='mt-3 form'>
                        <DataTable items={items} pageSize={10} columns={columns}></DataTable>
                     </div>
                  </div>
                  <div className='col-md-6'>
                     <div className='mt-3'>
                        <h6>Token</h6>
                        <textarea rows='45' cols='60' value={token} />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}

const validation = Yup.object({
   meterNumber: Yup.string().required('meter number is required'),
   tokens: Yup.number().min(1, 'number of tokens must 1 or more').required('number of tokens Required'),
});
